(function () {
  'use strict';

  function computeCount(nowSeconds, epochSeconds, intervalSeconds) {
    if (!Number.isFinite(intervalSeconds) || intervalSeconds <= 0) return 0;
    var elapsed = nowSeconds - epochSeconds;
    if (elapsed <= 0) return 0;
    return Math.floor(elapsed / intervalSeconds);
  }

  function formatCount(n) {
    return String(Math.trunc(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var easeOutExpo = function (t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  };

  class SpikeyCounter extends HTMLElement {
    connectedCallback() {
      this.figure = this.querySelector('[data-counter-figure]');
      if (!this.figure) return;

      this.epoch = parseInt(this.dataset.epoch, 10);
      this.interval = parseInt(this.dataset.interval, 10);
      this.shouldAnimate = this.dataset.animate === 'true' && !prefersReducedMotion();

      // data-initial is the server-computed value. Trust the client clock for the
      // live value, since a cached page can serve a stale data-initial.
      var fallback = parseInt(this.dataset.initial, 10);
      if (!Number.isFinite(this.epoch) || !Number.isFinite(this.interval) || this.interval <= 0) {
        if (Number.isFinite(fallback)) this.figure.textContent = formatCount(fallback);
        return;
      }

      this.render(this.current());

      if (this.shouldAnimate && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0.4 });
        this.observer.observe(this);
      }

      // Recompute from the clock every second rather than incrementing, so the
      // value cannot drift and a backgrounded tab catches up on return.
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      if (this.observer) this.observer.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    current() {
      return computeCount(Math.floor(Date.now() / 1000), this.epoch, this.interval);
    }

    render(value) {
      if (value === this.shown) return;
      this.shown = value;
      this.figure.textContent = formatCount(value);
    }

    tick() {
      if (this.animating) return;
      this.render(this.current());
    }

    onIntersect(entries) {
      var entry = entries[0];
      if (!entry || !entry.isIntersecting || this.hasCountedUp) return;
      this.hasCountedUp = true;
      if (this.observer) this.observer.disconnect();
      this.countUp();
    }

    countUp() {
      var target = this.current();
      var from = Math.floor(target * 0.97);
      if (from >= target) return;

      var duration = 1400;
      var start = performance.now();
      var self = this;
      this.animating = true;

      function frame(now) {
        var t = Math.min((now - start) / duration, 1);
        var value = Math.floor(from + (target - from) * easeOutExpo(t));
        self.render(value);
        if (t < 1) {
          self.raf = requestAnimationFrame(frame);
        } else {
          self.animating = false;
          self.render(self.current());
        }
      }

      this.raf = requestAnimationFrame(frame);
    }
  }

  if (!customElements.get('spikey-counter')) {
    customElements.define('spikey-counter', SpikeyCounter);
  }
})();
